module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"productDetails":"Produktdetails","deliveryReturns":"Versand & Retoure","freeReturns":"Kostenlose Retoure.","moreDeliveryInfo":"Versandinformationen"},"en":{"productDetails":"Product Details","deliveryReturns":"Delivery & Returns","freeReturns":"Free return for all orders.","moreDeliveryInfo":"Delivery information"}}')
  delete Component.options._Ctor
}
